// import { createBrowserHistory } from 'history';
// export const history = createBrowserHistory();

// import { createBrowserHistory } from "history";
//  const history = createBrowserHistory();
// export default history;


import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();